// extracted by mini-css-extract-plugin
module.exports = {"button":"BarDie_button__3vXmM","disabled":"BarDie_disabled__1I0Bd"};